import { V2EmptyState } from "@stacklet/ui";
import { graphql, useFragment } from "react-relay";

import { IdentityProviderCard } from "./IdentityProviderCard";

import type { IdentityProviders_query$key } from "./__generated__/IdentityProviders_query.graphql";

/** Props for the IdentityProviders component */
interface Props {
  /** Fragment reference for the query the provider list is read from */
  queryRef: IdentityProviders_query$key;
}

/**
 * The list of identity providers configured for the site, one card per
 * provider. `samlProviders` is a plain list rather than a connection, so the
 * whole set loads with the page.
 */
export function IdentityProviders({ queryRef }: Props) {
  const data = useFragment(
    graphql`
      fragment IdentityProviders_query on Query {
        samlProviders {
          id
          ...IdentityProviderCard_provider
        }
      }
    `,
    queryRef,
  );

  if (data.samlProviders.length === 0) {
    return (
      <V2EmptyState message="No identity providers are configured for this site." />
    );
  }

  return (
    <div className="flex flex-col gap-y-md">
      {data.samlProviders.map((provider) => (
        <IdentityProviderCard key={provider.id} providerRef={provider} />
      ))}
    </div>
  );
}
